import { Injectable } from "@angular/core";
import { Column } from "@universal-ui";

import { TextAlignment } from "@shared/Enums/text-alignment.enum";

@Injectable()
export class CanalesDashboardService {
  public setColumns(actionsTemplate: null): Column[] {
    return [
      {
        name: "Acciones",
        prop: "",
        width: 200,
        headerClass: TextAlignment.Center,
        cellTemplate: actionsTemplate,
        selected: true,
        dontPrint: true,
      },
      {
        name: "Identificación",
        prop: "metadata.numeroIdentificacion",
        selected: true,
      },
      {
        name: "Nombres",
        prop: "metadata.nombres",
        selected: true,
      },
      {
        name: "Apellidos",
        prop: "metadata.apellidos",
        selected: true,
      },
      {
        name: "Correo Electrónico",
        prop: "metadata.email",
        width: 250,
        selected: true,
      },
      {
        name: "Código de Usuario",
        prop: "metadata.userCode",
        selected: true,
      },
      {
        name: "Perfil",
        prop: "perfil.nombre",
        selected: true,
      },
      {
        name: "Roles",
        prop: "roles",
        selected: true,
      },
      {
        name: "Empresa",
        prop: "metadata.empresa",
        selected: true,
      },
      {
        name: "Teléfono",
        prop: "metadata.telephone",
        selected: true,
      },
      {
        name: "Fecha de Creación",
        prop: "formattedCreado",
        selected: true,
      },
      {
        name: "Provincia",
        prop: "provincia",
        selected: true,
      },
    ];
  }
}
